import React from 'react';
import connect from 'react-redux/es/connect/connect';
import PropTypes from 'prop-types';
import { getFilterStrings } from 'redux/reducers';

import ConfiguratorDropdown from 'components/ConfiguratorDropdown';

import './FilterSelection.css';

const labels = {
  patientParameter: 'patient-parameter',
  parameterOption: 'parameter-option',
  patientCategory: 'patient-category',
  usageCategory: 'usage-category'
};

const FilterSelection = (props) => {
  const {
    disabledOptions, getString, filterTag, onDrop, options, startOpen, value
  } = props;
  const dropAreaFiller = () => ([
    <div key="arrow" className="arrow-right" />,
    <span
      key="label"
      dangerouslySetInnerHTML={{ __html: value !== '' ? getString(value, 'filter') : getString(labels[filterTag], 'filter') }}
    />
  ]
  );
  return (
    <div className="dropdown">
      {
        (value !== '' || !startOpen) && options.length > 1 ? (
          <button
            type="button"
            onClick={() => onDrop(filterTag)}
            className="dropbtn"
          >
            {dropAreaFiller()}
          </button>
        ) : (
          <div className="dropbtn">
            {dropAreaFiller()}
          </div>
        )
      }
      {value === '' && startOpen
        ? (
          <div className="dropdown-content">
            <ConfiguratorDropdown
              getString={getString}
              id={filterTag}
              disabledOptions={disabledOptions || []}
              {...props}
            />
          </div>
        )
        : null}
    </div>
  );
};

FilterSelection.defaultProps = {
  disabledOptions: []
};
FilterSelection.propTypes = {
  disabledOptions: PropTypes.arrayOf(PropTypes.string),
  filterTag: PropTypes.string.isRequired,
  getString: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  startOpen: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired
};

export default connect(
  state => ({
    getString: state.strings.getString
  }),
)(FilterSelection);
